<template>
	<resource-list-item-skeleton :image="!withoutThumbnail" :image-width="imageWidth" :image-ratio="3/2" title subtitle description divided>
		<skeleton height="13" rounded min-width="90" max-width="140" class="mb-6 mt-12"/>
		<skeleton height="13" rounded width="120" class="mb-6"/>
	</resource-list-item-skeleton>
</template>

<script>
export default {
    name: 'EventJobListItemSkeleton',

    props: {
        smallThumbnail: {
            type: Boolean,
            default: false
        },
        withoutCreator: {
            type: Boolean,
            default: false
        },
        withoutThumbnail: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        imageWidth() {
            return !this.smallThumbnail && this.$breakpoint.smAndUp ? 160 : 64;
        }
    }

}
</script>

